import injectCSS from "../../../html/inject-css";
import registerListener from "../../../html/register-listener";


// @ts-ignore
import { data as stylesheet } from "./draggable-handle.css";

export type HandleDragEvent = { dx: number, dy: number };

export class DraggableHandle extends HTMLElement {

    startX?: number;
    startY?: number;

    constructor() {
        super();
        injectCSS(stylesheet);

        registerListener(this, 'pointerdown', this.pointerDown);
    }

    pointerDown = (event: PointerEvent) => {
        if(event.isPrimary) {
            this.startX = event.clientX;
            this.startY = event.clientY;
            registerListener(window, 'pointermove', this.pointerMove);
            registerListener(window, 'pointerup', this.pointerUp);
            this.dispatchEvent(new CustomEvent('handle-grab'));
        }
    }

    pointerMove = (event: PointerEvent) => {
        this.dispatchEvent(new CustomEvent<HandleDragEvent>('handle-drag', {
            detail: {
                dx: event.clientX - this.startX,
                dy: event.clientY - this.startY,
            }
        }));
    }

    pointerUp = () => {
        removeEventListener('pointermove', this.pointerMove);
        removeEventListener('pointerup', this.pointerUp);
    }
}
customElements.define('draggable-handle', DraggableHandle);
export default DraggableHandle;
